import {RouteProps} from 'config/navigation';

import Neighborhoods from './neighborhoods';
import CreateNeighborhood from './create-neighborhood';
import EditNeighborhood from './edit-neighborhood';
import {BsFillHousesFill} from 'react-icons/bs';

const neighborhoodsPages: RouteProps = {
  name: 'Bairros',
  path: 'neighborhoods',
  permission: 'neighborhoods.findAll',
  icon: <BsFillHousesFill />,
  subRoutes: [
    {
      path: '',
      element: <Neighborhoods />,
      permissions: ['neighborhoods.findAll'],
    },
    {
      path: 'create',
      element: <CreateNeighborhood />,
      permissions: ['neighborhoods.findOne'],
    },
    {
      path: ':id',
      element: <EditNeighborhood />,
      permissions: ['neighborhoods.findOne'],
    },
  ],
};

export default neighborhoodsPages;
